import styled from 'styled-components';

export const styledHourField = (Component) => styled(Component)`
  .field-container {
    > div {
      width: 136px;
    }

    svg {
      width: 16px;
      height: 16px;
      margin-bottom: 10px;

      path {
        fill: grey;
      }
    }
  }
`;

export default styledHourField;
